const configs = {
  development: {
    mapbox: {
      username: 'zencity',
      styleId: 'ckl54obsb21j717p18kq6m0l7',
      accessToken:
        'pk.eyJ1IjoiemVuY2l0eSIsImEiOiJjbHBqdGh6ZWIwM2dzMmpxdmo0dGQwZnE0In0.-yhSTQitJDMOvyDgk_FXzA',
    },
  },
  production: {
    mapbox: {
      username: 'zencity',
      styleId: 'ckl54obsb21j717p18kq6m0l7',
      accessToken:
        'pk.eyJ1IjoiemVuY2l0eSIsImEiOiJjbG95YXVvN2MwMmYzMnFsbXN3aWZvZmRiIn0.B-VuNVZhUT8BsofPK1WdKg',
    },
  },
  staging: {
    mapbox: {
      username: 'zencity',
      styleId: 'ckl54obsb21j717p18kq6m0l7',
      accessToken:
        'pk.eyJ1IjoiemVuY2l0eSIsImEiOiJjbG95YXVvN2MwMmYzMnFsbXN3aWZvZmRiIn0.B-VuNVZhUT8BsofPK1WdKg',
    },
  },
  test: {
    mapbox: {
      username: 'zencity',
      styleId: 'ckl54obsb21j717p18kq6m0l7',
      accessToken:
        'pk.eyJ1IjoiemVuY2l0eSIsImEiOiJjbHBqdGh6ZWIwM2dzMmpxdmo0dGQwZnE0In0.-yhSTQitJDMOvyDgk_FXzA',
    },
  },
};

const config = configs[process.env.NODE_ENV];

export default config;
